import { render, staticRenderFns } from "./InvitationalPortComponent.vue?vue&type=template&id=8b46a3a6&scoped=true"
import script from "./InvitationalPortComponent.vue?vue&type=script&lang=js"
export * from "./InvitationalPortComponent.vue?vue&type=script&lang=js"
import style0 from "./InvitationalPortComponent.vue?vue&type=style&index=0&id=8b46a3a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b46a3a6",
  null
  
)

export default component.exports